<p-toast></p-toast>
<ng-container *ngIf="currentUser.empresa.tipo === tipoNormal && currentUser.cajero" >
    <div class="flex justify-content-center" *ngIf="!this.currentUser.cajero">
        <div class="card">
            <p-calendar class="pr-1 pl-1 " [ngClass]="isMobileView ? 'date-small' : 'date-normal' " [(ngModel)]="fromDate" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>
            <p-calendar class="pr-1 " [ngClass]="isMobileView ? 'date-small' : 'date-normal' "  [(ngModel)]="toDate" dateFormat="dd/mm/yy" appendTo="body"></p-calendar>    
            <button pButton pRipple class="p-button-success" [ngClass]="isMobileView ? 'btn-small' : 'btn-normal'" [label]="isMobileView ? '' : 'Buscar'" icon="pi pi-search" (click)="buscar()"></button>       
        </div>
    </div>
    <div class="flex justify-content-end" *ngIf="this.currentUser.cajero">
        <div class="card card-close-rendicion" (click)="cerrarCaja()">
            <div class="text-close">CERRAR CAJA</div>
            <i class="pi pi-times icon-close"></i>
        </div>
    </div>
    <br>
    <div class="grid">
        <div class="col-12 md:col-6">
            <div class="card card-style">
                <div class="card-header-ingreso flex justify-content-between">
                    <span>INGRESOS</span>
                    <div>{{ totalIngreso | currency:'':'Gs.':'0.0-0':'es-PY'}}</div>
                </div>
                <div class="grid p-3">
                    <div *ngFor="let ingreso of ingresos; let i=index" class="col-12 md:col-4">
                        <div class="card card-concepto-ingreso" (click)="currentUser.cajero ? nuevaRendicion(ingreso) : informeRendiciones(ingreso)">
                            <div class="card-concepto-title-ingreso">{{ i + 1 }}- {{ ingreso.nombre }}</div>
                            <div class="card-concepto-monto">{{ ingreso.monto | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-style">
                <div class="card-header-ingreso flex justify-content-between">
                    <span>Otros Valores</span>
                    <div>{{ totalOtrosValores | currency:'':'Gs.':'0.0-0':'es-PY'}}</div>
                </div>
                <div class="grid p-3">
                    <div *ngFor="let otroValor of otrosValores; let i=index" class="col-12 md:col-4">
                        <div class="card card-concepto-ingreso" (click)="currentUser.cajero ? nuevaRendicion(otroValor) : informeRendiciones(otroValor)">
                            <div class="card-concepto-title-ingreso">{{ i + 1 }}- {{ otroValor.nombre }}</div>
                            <div class="card-concepto-monto">{{ otroValor.monto | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-6">
            <div class="card card-style">
                <div class="card-header-egreso flex justify-content-between">
                    <span>EGRESOS</span>
                    <div>{{ totalEgreso | currency:'':'Gs.':'0.0-0':'es-PY'}}</div>
                </div>
                <div class="grid p-3">
                    <div *ngFor="let egreso of egresos; let i=index" class="col-12 md:col-4">
                        <div class="card card-concepto-egreso" (click)="currentUser.cajero ? nuevaRendicion(egreso) : informeRendiciones(egreso)">
                            <div class="card-concepto-title-egreso">{{ i + 1 }}- {{ egreso.nombre }}</div>
                            <div class="card-concepto-monto">{{ egreso.monto | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-style">
                <div class="card-header-resumen flex justify-content-center">
                    <span>RESUMEN - {{ fromDate | date: 'dd/MM/yyyy' }} al {{ toDate | date: 'dd/MM/yyyy' }}</span>
                </div>
                <div class="grid pl-3 pr-3 resumen-card">
                    <ng-container *ngFor="let item of rendicionCajas">
                        <div class="col-12">
                            <div class="grid flex justify-content-end">
                                <div class="col-4">
                                    <div class="card card-concepto-resumen" (click)="item.total_valores > 0 ? informeRendicionesCaja(): ''">
                                        <div class="card-concepto-title-resumen">VALORES</div>
                                        <div class="card-concepto-monto">{{ item.total_valores | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="card card-concepto-resumen" (click)="item.saldo_actual > 0 ? informeRendicionesCaja(): ''">
                                        <div class="card-concepto-title-resumen">SALDO ACTUAL</div>
                                        <div class="card-concepto-monto">{{ item.saldo_actual | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="card card-concepto-resumen" (click)="item.total_valores - item.saldo_actual > 0 ? informeRendicionesCaja(): ''">
                                        <div class="card-concepto-title-resumen">FALTANTE/SOBRANTE</div>
                                        <div class="card-concepto-monto">{{ item.total_valores - item.saldo_actual | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="grid lfex justify-content-center">
                                <div class="col-4">
                                    <div class="card card-concepto-resumen"  (click)="item.ingresos > 0 ? informeRendicionesCaja(): ''">
                                        <div class="card-concepto-title-resumen">INGRESOS</div>
                                        <div class="card-concepto-monto">{{ item.ingresos | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="card card-concepto-resumen" (click)="item.egresos > 0 ? informeRendicionesCaja(): ''">
                                        <div class="card-concepto-title-resumen">EGRESOS</div>
                                        <div class="card-concepto-monto">{{ item.egresos | currency:'':'Gs.':'0.0-0':'es-PY' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>                    
                </div>
            </div>
        </div>
    </div>
</ng-container>



<!-- Rendicion Dialog -->
<p-dialog [(visible)]="showDialogRendicion" position="center" (onShow)="setFocus()"  modal="true" header="{{ fgRendicion?.value?.nombre_concepto_principal }}" [breakpoints]="{'960px': '75vw', '400px': '95vw'}" [style]="{width: '50vw'}" [closeOnEscape]="false" [closable]="false" >
    <div class="grid">
        <div class="col-12">
            <form *ngIf="fgRendicion" [formGroup]="fgRendicion">
                <div class="p-fluid p-formgrid grid flex align-items-center flex-wrap">
                    <div class="field col-12 md:col-3">
                        <label htmlFor="monto">Monto</label>
                        <p-inputNumber #input inputId="monto" formControlName="monto"></p-inputNumber>
                    </div>
                    <div class="field col-12 md:col-5">
                        <label htmlFor="comentario">Comentario</label>
                        <input  pInputText id="comentario" type="text" formControlName="comentario" />
                        <small *ngIf="invalidControlDetalle(fgRendicion, 'comentario')" style="color: red;">Este campo es requerido.</small>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="referencia">Referencia</label>
                        <input pInputText id="referencia" type="text" formControlName="referencia" />
                        <small *ngIf="invalidControlDetalle(fgRendicion, 'referencia')" style="color: red;">Este campo es requerido.</small>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="codigo_concepto_secundario">Concepto</label>
                        <span class="p-input-icon-right">
                            <input pInputText id="codigo_concepto_secundario" type="text" formControlName="codigo_concepto_secundario" (change)="onConcepto()" 
                                (keydown.control.enter)="!isReadonly() ? onListaConcepto() : ''" />
                            <i style="font-size: 1.2rem;" class="pi pi-search" (click)="onListaConcepto()"></i>
                        </span>
                        <small *ngIf="mostrarErrorConcepto" style="color: red;">Este campo es requerido.</small>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="nombre_concepto_secundario">Descripción</label>
                        <input pInputText id="nombre_concepto_secundario" type="text" formControlName="nombre_concepto_secundario" readonly />
                        <small *ngIf="mostrarErrorConcepto" style="color: red;">Este campo es requerido.</small>
                    </div>
                </div>
                <hr>
                <div class="grid flex align-items-center p-fluid">
                    <div class="col-6">
                        <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-warning" label="Cancelar" (click)="cancelarRendicion()"></button>
                    </div>
                    <div class="col-6">
                        <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded" label="Confirmar" (click)="confirmarRendicion()"></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</p-dialog>

<ng-container *ngIf="currentUser.empresa.tipo === tipoInversionista">
    <div class="col-12">
        <div class="p-fluid grid flex justify-content-center">
            <div class="col-12 md:col-3" >
                <div class="card custom-card-style color2 flex justify-content-center align-items-center">
                    <b class="mr-1">Desembolso Anual: {{ totalDesembolso | currency: '':'Gs':'0.0':'es-PY'}}</b><b></b>
                </div>
            </div>
            <div class="col-12 md:col-3"  >
                <div class="card custom-card-style color1 flex justify-content-center align-items-center">
                    <b class="mr-1">Cobranza Anual: {{totalCobro | currency: '':'Gs':'0.0':'es-PY'}}</b><b></b>
                </div>
            </div>
            <div class="col-12 md:col-3" >
                <div class="card custom-card-style color2 flex justify-content-center align-items-center">
                    <b class="mr-1">Desembolso Del Mes: {{desembolsoMesActual | currency: '':'Gs':'0.0':'es-PY'}}</b><b></b>
                </div>
            </div>
            <div class="col-12 md:col-3"  >
                <div class="card custom-card-style color1 flex justify-content-center align-items-center">
                    <b class="mr-1">Cobranza del Mes: {{ cobroMesActual | currency: '':'Gs':'0.0':'es-PY'}}</b><b></b>
                </div>
            </div>
        </div>
    </div>
    <div class="card col-12">
        <div class="flex flex-row justify-content-center">
            <span class="p-1 m-1 fs-normal">
                <!-- <b style="font-size: 1.2rem; margin-right: 1rem;">Transacciones: <span style="color: red;">{{ TrxDiaVenta | currency:'':'':'0.0-0':'es-PY' }}</span></b> -->
                <b style="font-size: 1.2rem;">Registro Anual de Prestamos Solidarios</b>
            </span>
        </div>
        <p-chart type="line" [data]="ordersChart" [options]="ordersOptions" height="300px"></p-chart>
    </div>
</ng-container>


<!-- Rendicion Dialog -->
<p-dialog [(visible)]="showDialogRendicion" position="center" (onShow)="setFocus()"  modal="true" header="{{ fgRendicion?.value?.nombre_concepto_principal }}" [breakpoints]="{'960px': '75vw', '400px': '95vw'}" [style]="{width: '50vw'}" [closeOnEscape]="false" [closable]="false" >
    <div class="grid">
        <div class="col-12">
            <form *ngIf="fgRendicion" [formGroup]="fgRendicion">
                <div class="p-fluid p-formgrid grid flex align-items-center flex-wrap">
                    <div class="field col-12 md:col-3">
                        <label htmlFor="monto">Monto</label>
                        <p-inputNumber #input inputId="monto" formControlName="monto"></p-inputNumber>
                    </div>
                    <div class="field col-12 md:col-5">
                        <label htmlFor="comentario">Comentario</label>
                        <input  pInputText id="comentario" type="text" formControlName="comentario" />
                        <small *ngIf="invalidControlDetalle(fgRendicion, 'comentario')" style="color: red;">Este campo es requerido.</small>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="referencia">Referencia</label>
                        <input pInputText id="referencia" type="text" formControlName="referencia" />
                        <small *ngIf="invalidControlDetalle(fgRendicion, 'referencia')" style="color: red;">Este campo es requerido.</small>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="codigo_concepto_secundario">Concepto</label>
                        <span class="p-input-icon-right">
                            <input pInputText id="codigo_concepto_secundario" type="text" formControlName="codigo_concepto_secundario" (change)="onConcepto()" 
                                (keydown.control.enter)="!isReadonly() ? onListaConcepto() : ''" />
                            <i style="font-size: 1.2rem;" class="pi pi-search" (click)="onListaConcepto()"></i>
                        </span>
                        <small *ngIf="mostrarErrorConcepto" style="color: red;">Este campo es requerido.</small>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="nombre_concepto_secundario">Descripción</label>
                        <input pInputText id="nombre_concepto_secundario" type="text" formControlName="nombre_concepto_secundario" readonly />
                        <small *ngIf="mostrarErrorConcepto" style="color: red;">Este campo es requerido.</small>
                    </div>
                </div>
                <hr>
                <div class="grid flex align-items-center p-fluid">
                    <div class="col-6">
                        <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-warning" label="Cancelar" (click)="cancelarRendicion()"></button>
                    </div>
                    <div class="col-6">
                        <button pButton pRipple type="button" icon="pi pi-check" class="p-button-rounded" label="Confirmar" (click)="confirmarRendicion()"></button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</p-dialog>


<div class="grid m-auto col-8 pt-6" *ngIf="currentUser.empresa.tipo === tipoNormal  && !currentUser.cajero">
    <div class="col-12 md:col-6 pb-3">
    <!-- <div class="col-12 md:col-6 pb-3" *ngIf="tesoreria"> -->
        <div class="color card menu img-hover flex align-items-center" (click)="grafico()">
            <img src="./assets/images/grafico-circular.png" alt="Imagen Gráficos" class="hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo"> <b>Envio de extractos y Flyers</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="mostrarMenuCajero">
        <div class="color card menu img-hover flex align-items-center" (click)="cajero()">
            <img src="./assets/images/cajero.png" alt="Imagen Gráficos" class=" hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo "> <b>Caja</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="configuracion">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('configuracion')">
            <img src="./assets/images/ajustes.png" alt="Imagen Gráficos" class=" hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo "> <b>Configuración</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="tesoreria">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('tesoreria')">
            <img src="./assets/images/cuenta-bancaria.png" alt="Imagen Gráficos" class="hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo"> <b>Tesoreria</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="tarjeta">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('cliente_tarjeta')">
            <img src="./assets/images/tarjeta.png" alt="Imagen Gráficos" class="hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo"> <b>Tarjeta</b></div>
        </div>
    </div>        
    <div class="col-12 md:col-6 pb-3" *ngIf="prestamo">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('prestamo')">
            <img src="./assets/images/pago.png" alt="Imagen Gráficos" class="hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo "> <b>Prestamo</b></div>
        </div>
    </div> 
     <div class="col-12 md:col-6 pb-3" *ngIf="prestamo_solidario">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('prestamo_solidario')">
            <img src="./assets/images/prestamo-solidario.png" alt="Imagen Gráficos" class=" hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo "> <b>Prestamo Solidario</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="contabilidad">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('contabilidad')">
            <img src="./assets/images/calculadora.png" alt="Imagen Inventario" class="hover-container centered-image col-6">
            <div class="col-6 flex align-items-center justify-content-center titulo"><b>Contabilidad</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="notificacion">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('notificacion')">
            <img src="./assets/images/notificacion.png" alt="Imagen Gráficos" class="hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo "> <b>Notificación</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="crm">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('crm')">
            <img src="./assets/images/crm.png" alt="Imagen Gráficos" class="hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo "> <b>CRM</b></div>
        </div>
    </div>
    <div class="col-12 md:col-6 pb-3" *ngIf="seguridad">
        <div class="color card menu img-hover flex align-items-center" (click)="accesos('seguridad')">
            <img src="./assets/images/candado.png" alt="Imagen Gráficos" class="hover-container centered-image col-6">
            <div class="col-6 flex aling-items-center justify-content-center titulo "> <b>Seguridad</b></div>
        </div>
    </div>
</div>

<p-dialog [(visible)]="mostrarVentana" position="bottom" modal="true" [header]=nombreVentana  [breakpoints]="{'960px': '75vw', '400px': '95vw'}" 
[style]="{width: '80vw'}" [closeOnEscape]="true" >
    <div class="grid justify-content-center">
        <div class="col-12 md:col-4">
            <div class="card flex justify-content-center registro m-0">
                <div class="texto"><b>Registros</b></div>
            </div>
            <hr>
            <div class="grid">
                <div class="col-12 espaciado"  *ngFor="let registro of registros">
                    <div class="card items item1 p-3" (click)="onNavigate(registro.routerLink)" >
                        <div class="flex flex-row flex-wrap align-items-center justify-content-start">
                            <i class="pi pi-book icono" ></i>
                            <label for="" class="pl-2">{{ registro.label }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-4" *ngIf="reportes">
            <div class="card flex justify-content-center reporte m-0">
                <div class="texto"><b>Reportes</b></div>
            </div>
            <hr>
            <div class="grid">
                <div class="col-12 espaciado" *ngFor="let reporte of reportes.items" >
                    <div class="card items item2 p-3" (click)="onNavigate(reporte.routerLink)">
                        <div class="flex flex-row flex-wrap align-items-center justify-content-start">
                            <i class="pi pi-file icono2" ></i>
                            <label for="" class="pl-2">{{ reporte.label }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 md:col-4" *ngIf="procesos">
            <div class="card flex justify-content-center proceso m-0">
                <div class="texto"><b>Procesos</b></div>
            </div>                
            <hr>
            <div class="grid">
                <div class="col-12 espaciado" *ngFor="let proceso of procesos.items" >
                    <div class="card items item3 p-3" (click)="onNavigate(proceso.routerLink)">
                        <div class="flex flex-row flex-wrap align-items-center justify-content-start">
                            <i class="pi pi-cog icono3" style="font-size: 2rem"></i>
                            <label for="" class="pl-2 ">{{ proceso.label }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>  


<app-on-lista [show]="showOnLista" [title]="tituloOnLista" [columns]="columnasOnLista" [service]="serviceOnLista" [recordName]="recordNameOnLista" [filters]="filters" 
    (close)="cerrarOnLista($event)">
</app-on-lista>